module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "cont"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "cont"
    }
  }), _c('p', {
    staticClass: "toc-heada"
  }, [_c('a', {
    attrs: {
      "id": "cont"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_c('strong', [_vm._v("EVERYDAY ZAKKA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev1sec1"
    }
  }, [_vm._v("Eraser Stamped Lavender Sachet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev1sec2"
    }
  }, [_vm._v("Crochet-Edged One-Yard Scarf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev1sec3"
    }
  }, [_vm._v("Patchwork Lanyard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev1sec4"
    }
  }, [_vm._v("Rice Therapy Eye Pillow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev1sec5"
    }
  }, [_vm._v("Matryoshka Doll Key Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev1sec6"
    }
  }, [_vm._v("Fabric Bucket with Hangtag")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01lev1sec7"
    }
  }, [_vm._v("Cotton Flower Bag Charm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-heada"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("BAGS AND POUCHES ZAKKA STYLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02lev1sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kotori Zipper Pouch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02lev1sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Raindrops Tote")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02lev1sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roll-Up Eco Shopper Bag")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02lev1sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mini Drawstring Pouch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02lev1sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vintage Ribbon Flex Frame Pouch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02lev1sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crochet Doily and Linen Pouch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02lev1sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple Linen Tote")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-heada"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("BABY AND YOUNG CHILD ZAKKA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03lev1sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patchwork Bib")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03lev1sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bunny or Panda? Soft Ring Toy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03lev1sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reversible Baby Shoes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03lev1sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Puffy Ponytail Bow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03lev1sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Children’s Pencil Bag")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-heada"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("HANDMADE KITCHEN ZAKKA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04lev1sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Airmail Mug Rug")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04lev1sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sashiko-Style Coasters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04lev1sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Insulated Bento Lunch Bag")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04lev1sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wrap-Around Chopsticks Holder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04lev1sec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cutlery Carrier")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-seca"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04lev1sec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patterns")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2f1bd96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cont.vue
// module id = 60
// module chunks = 0